import { pick } from './obj'
import { removeEmptyKeys } from './objects'

const ADDRESS_KEYS = [
  'addressline1',
  'addressLine1',
  'addressline2',
  'addressLine2',
  'summaryline',
  'summaryLine',
  'uniquedeliverypointreferencenumber',
  'posttown',
  'postTown',
  'postcode',
  'uprn',
  'udprn'
]

export const QLJAddressFormat = (address) => {
  const formattedAddress = pick(ADDRESS_KEYS, address)
  return removeEmptyKeys(formattedAddress)
}

export const addNonBreakingSpaceToPostcode = (summaryLine = '') => {
  const addressParts = summaryLine.split(', ').slice(0, -1)
  const postcodePart = summaryLine.split(', ').slice(-1)[0].replace(' ', '\u00A0')

  return [...addressParts, postcodePart].join(', ')
}
